export default __webpack_public_path__ + "static/media/payment.f8c8f2b7.svg";